var _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoAccess = function SvgNoAccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M886.7,199.9l3.1-3.1l-86.6-86.6l-3.1,3.1C717.2,48.8,613.3,10,500,10C229.4,10,10,229.5,10,500c0,113.2,38.8,217.1,103.3,300.1l-3.1,3.1l86.6,86.6l3.1-3.1C282.8,951.2,386.7,990,500,990c270.6,0,490-219.5,490-490C990,386.8,951.2,282.9,886.7,199.9z M132.5,500c0-202.7,164.8-367.5,367.5-367.5c79.3,0,152.5,25.5,212.7,68.3L200.7,712.6C158,652.5,132.5,579.3,132.5,500z M500,867.5c-79.3,0-152.5-25.5-212.7-68.3l511.9-511.8c42.8,60.1,68.2,133.3,68.2,212.6C867.5,702.7,702.7,867.5,500,867.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-access.1df7be19ffc8f1e029624ca1396f2d01.svg";